import styles from './date.module.scss';
import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { ArrowBackIcon } from 'components/icons';
import { formatDate, parseDate } from 'react-day-picker/moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import Button from 'components/Form/Button';
import { globalStyles } from 'styles';
import classname from 'classname';
export default function Date({
  handleClose,
  date,
  setDate,
  handleFilterClick,
  showFilterButton,
}) {
  const handleDayClick = (day) => {
    const range = DateUtils.addDayToRange(day, date);
    setDate(range);
  };

  const handleFromChange = (from) => {
    setDate({ ...date, from });
  };

  const handleToChange = (to) => {
    setDate({ ...date, to });
  };

  const { from, to } = date;
  const modifiers = { start: from, end: to };
  return (
    <div className={styles.container}>
      <div className={styles.headingcontainer}>
        <button onClick={handleClose}>
          <ArrowBackIcon
            style={{ marginRight: '5px', marginTop: '-2px', cursor: 'pointer' }}
          />
        </button>
        <h4 className={styles.heading}>Select Custom Date</h4>
      </div>
      <div className={styles.inputGroup}>
        <div>
          <p className={styles.title}>From</p>
          <DayPickerInput
            value={from}
            placeholder="Pick from date"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            onDayChange={handleFromChange}
          />
        </div>
        <div>
          <p className={styles.title} value={formatDate(to)}>
            To
          </p>
          <DayPickerInput
            value={to}
            placeholder="Pick to date"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            onDayChange={handleToChange}
          />
        </div>
      </div>
      <DayPicker
        weekdaysShort={['S', 'M', 'T', 'W', 'T', 'F', 'S']}
        selectedDays={date}
        selectedDays={[from, { from, to }]}
        modifiers={modifiers}
        onDayClick={handleDayClick}
      />
      <div
        className={classname(globalStyles.flex, globalStyles.justifyContentEnd)}
      >
        {showFilterButton && (
          <Button variant="primary" small onClick={handleFilterClick}>
            Apply filter
          </Button>
        )}
      </div>
    </div>
  );
}
